const rankingItems = [
  {
    rank: 1,
    title: '顶流艺人深夜密会事件持续发酵，多方回应引连锁反应',
    category: '娱乐圈',
    heat: '🔥 2,847万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '某科技巨头被曝内部大调整，行业格局或将重塑',
    category: '科技圈',
    heat: '🔥 2,103万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '社交平台服务器崩溃事件背后：流量洪峰下的技术考验',
    category: '互联网',
    heat: '🔥 1,876万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '体育明星转会传闻再起，多方消息指向惊人去向',
    category: '体育界',
    heat: '🔥 1,654万',
    trend: 'up',
  },
  {
    rank: 5,
    title: '上市公司财务造假风波升级，监管介入调查',
    category: '财经圈',
    heat: '🔥 1,432万',
    trend: 'down',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新 · 每日大赛热度排行 TOP5
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 transition-all hover:border-primary-200 cursor-pointer group"
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-bold text-lg ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 flex-wrap">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.category}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                  </div>
                </div>

                <div className="flex-shrink-0">
                  <i className={`text-lg ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : 'ri-arrow-down-line text-secondary-500'
                  }`}></i>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 text-center">
            <a
              href="#"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer no-underline whitespace-nowrap"
            >
              查看完整榜单
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}